(function () {
  try {
    const ip = "test-sudeste";
    const uf = "SP";
    const region = "Sudeste";

    window.__USER_IP__ = ip;
    window.__USER_UF__ = uf;
    window.__USER_REGION__ = region;

    window.dispatchEvent(
      new CustomEvent("user:region-ready", {
        detail: { region, uf, ip }
      })
    );

    document.querySelectorAll(".show-sudeste").forEach((el) => {
      el.classList.add("show-region-component");
    });
  } catch (err) {
    console.error(err);
  }
})();
